import * as e from "react";
import { forwardRef as r } from "react";
const a = r(function(t, l) {
  return /* @__PURE__ */ e.createElement(
    "svg",
    {
      fill: "none",
      ref: l,
      viewBox: "0 0 24 20",
      xmlns: "http://www.w3.org/2000/svg",
      ...t
    },
    /* @__PURE__ */ e.createElement("g", null, /* @__PURE__ */ e.createElement("path", { d: "M19.854 20H0L3.47936 0H23.3333L19.854 20Z", fill: "#212121" }), /* @__PURE__ */ e.createElement(
      "path",
      {
        d: "M10.5982 13.1482L14.7982 9.99815L10.5982 6.84814V13.1482Z",
        fill: "#fff"
      }
    ), /* @__PURE__ */ e.createElement(
      "path",
      {
        d: "M12 3C8.13252 3 5 6.13252 5 10C5 13.8675 8.13252 17 12 17C15.8675 17 19 13.8675 19 10C19 6.13248 15.8675 3 12 3ZM12 15.6C8.913 15.6 6.39998 13.087 6.39998 10C6.39998 6.91299 8.913 4.40001 12 4.40001C15.087 4.40001 17.6 6.91299 17.6 10C17.6 13.087 15.087 15.6 12 15.6Z",
        fill: "#fff"
      }
    )),
    /* @__PURE__ */ e.createElement("defs", null, /* @__PURE__ */ e.createElement("clipPath", null, /* @__PURE__ */ e.createElement("rect", { fill: "#fff", height: 20, width: 23.3333 })))
  );
});
export {
  a as LiveStreamingBadge
};
